import { MenuItem, Select } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { CollectionOpts } from 'json-api-hooks';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import Spinner from '../../Loading/Spinner';
import useFieldOptions from '../hooks/useFieldOptions';
import { ResourceFieldAttributes } from '../ResourceForm';
import { InputRenderer } from '../types';

const SelectInput = ({
  fieldState,
  inputProps,
  options: optionsProp,
  required,
  resource,
  resourceOpts,
  resourceType,
}: InputRenderer) => {
  const { loading, options } = useFieldOptions(
    optionsProp,
    resource,
    resourceType,
    resourceOpts as CollectionOpts | ((props: ResourceFieldAttributes<void>) => CollectionOpts),
  );

  if (loading) {
    return <Spinner />;
  }

  if (options.length === 0) {
    return null;
  }

  return (
    <>
      <Select
        error={fieldState?.invalid}
        id={inputProps.name}
        {...inputProps}
        IconComponent={
          inputProps.value.length > 0 && !required
            ? () => (
                <IconButton
                  size="small"
                  onClick={() => {
                    inputProps.onChange('');
                  }}
                >
                  <FontAwesome name="times" />
                </IconButton>
              )
            : undefined
        }
      >
        {options?.map((option) => (
          <MenuItem key={option.key} value={option.key}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default SelectInput;
